<template>
  <a-drawer
    :title="title"
    :width="width"
    placement="right"
    :closable="false"
    @close="close"
    :visible="visible">
  
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item label="知识库类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'knowledgeType', validatorRules.knowledgeType]" placeholder="请输入知识库类型"></a-input>
        </a-form-item>
        <a-form-item label="附件路径" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'url', validatorRules.url]" placeholder="请输入附件路径"></a-input>
        </a-form-item>
        <a-form-item label="文件名" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'name', validatorRules.name]" placeholder="请输入文件名"></a-input>
        </a-form-item>
        <a-form-item label="大小" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'size', validatorRules.size]" placeholder="请输入大小"></a-input>
        </a-form-item>
        <a-form-item label="下载次数" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number v-decorator="[ 'downloadCount', validatorRules.downloadCount]" placeholder="请输入下载次数" style="width: 100%"/>
        </a-form-item>
        <a-form-item label="查看次数" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number v-decorator="[ 'viewCount', validatorRules.viewCount]" placeholder="请输入查看次数" style="width: 100%"/>
        </a-form-item>
        <a-form-item label="是否显示" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number v-decorator="[ 'isShow', validatorRules.isShow]" placeholder="请输入是否显示" style="width: 100%"/>
        </a-form-item>
        <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'remark', validatorRules.remark]" placeholder="请输入备注"></a-input>
        </a-form-item>
        <a-form-item label="附件id" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'annexId', validatorRules.annexId]" placeholder="请输入附件id"></a-input>
        </a-form-item>
        <a-form-item label="文件类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'fileType', validatorRules.fileType]" placeholder="请输入文件类型"></a-input>
        </a-form-item>
        
      </a-form>
    </a-spin>
    <a-button type="primary" @click="handleOk">确定</a-button>
    <a-button type="primary" @click="handleCancel">取消</a-button>
  </a-drawer>
</template>

<script>

  import { httpAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  
  export default {
    name: "BusKnowledgeFileModal",
    components: { 
    },
    data () {
      return {
        form: this.$form.createForm(this),
        title:"操作",
        width:800,
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          knowledgeType: {rules: [
          ]},
          url: {rules: [
          ]},
          name: {rules: [
          ]},
          size: {rules: [
          ]},
          downloadCount: {rules: [
          ]},
          viewCount: {rules: [
          ]},
          isShow: {rules: [
          ]},
          remark: {rules: [
          ]},
          annexId: {rules: [
          ]},
          fileType: {rules: [
          ]},
        },
        url: {
          add: "/knowledge.file/busKnowledgeFile/add",
          edit: "/knowledge.file/busKnowledgeFile/edit",
        }
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'knowledgeType','url','name','size','downloadCount','viewCount','isShow','remark','annexId','fileType'))
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'post';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }
         
        })
      },
      handleCancel () {
        this.close()
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'knowledgeType','url','name','size','downloadCount','viewCount','isShow','remark','annexId','fileType'))
      }
      
    }
  }
</script>

<style lang="less" scoped>
/** Button按钮间距 */
  .ant-btn {
    margin-left: 30px;
    margin-bottom: 30px;
    float: right;
  }
</style>